let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i4Skc")).then(() => parcelRequire('6I2GO'));